export default "__VITE_ASSET__61b327ab__"